import { ContentType } from '@creditsights/api-ui-web';
import { ContentTypeTag } from './Article';

export enum ContentTypeFilter {
  ALL = 'All',
  RESEARCH = 'Research',
  COVENANTS = 'Covenants',
  NEWS = 'News',
}

export const ContentTypeFilterToContentTypeTag = {
  [ContentTypeFilter.NEWS]: ContentTypeTag.News,
  [ContentTypeFilter.COVENANTS]: ContentTypeTag.Covenants,
  [ContentTypeFilter.RESEARCH]: ContentTypeTag.Research,
};

export const ContentTypeFilterToContentType = {
  [ContentTypeFilter.NEWS]: ContentType.News,
  [ContentTypeFilter.COVENANTS]: ContentType.Covenants,
  [ContentTypeFilter.RESEARCH]: ContentType.Research,
};
